import React from 'react'
import Header from './Header'
import { useAuth } from '../../context/AuthContext'

const Layout = ({ children }) => {
  const { isAuthenticated } = useAuth()

  if (!isAuthenticated) {
    return children
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main>
        {children}
      </main>
    </div>
  )
}

export default Layout